export default __webpack_public_path__ + "static/media/newyear2025-large.f3b19cac.jpg";